// Page state for the all Worksheets Browsers within the app
// list of all WorksheetsBrowser parent views
import eventBus from '@/eventBus'
const parentViews = ['TestVideoBrowser']

const defaultLayoutValues = [
  {
    label: 'Grid',
    value: 'GRID',
    selected: true
  }
]

const defaultOptionValues = [
  {
    label: 'Kids in Motion',
    value: 'kids-in-motion',
    selected: false
  },
  {
    label: 'OVB Coach',
    value: 'ovb-coach',
    selected: false
  },
  {
    label: 'Primitive Reflex Library',
    value: 'primitive-reflex-library',
    selected: false
  },
  {
    label: 'We Move',
    value: 'we-move',
    selected: false
  },
  {
    label: 'Clinic Videos',
    value: 'clinic-videos',
    selected: false
  }
]

const cleanState = {
  name: null,
  selectedCategories: [],
  levelValue: 'ALL',
  searchTerm: null,
  optionValues: [],
  lastSelection: '',
  layoutValues: defaultLayoutValues
}
const generatePageStates = () => {
  const pgStatesList = []
  parentViews.forEach((vw) => {
    const newState = { ...cleanState }
    newState.name = vw
    pgStatesList.push(newState)
  })
  return pgStatesList
}

const types = {
  SET_LAYOUT: 'SET_LAYOUT',
  SET_LAYOUT_VALUES: 'SET_LAYOUT_VALUES',
  SET_LEVEL_VALUE: 'SET_LEVEL_VALUE',
  SET_OPTION_VALUES: 'SET_OPTION_VALUES',
  SET_CATEGORY_SELECTIONS: 'SET_CATEGORY_SELECTIONS',
  SET_SEARCH_TERM: 'SET_SEARCH_TERM',
  SET_LAST_SELECTION: 'SET_LAST_SELECTION',
  CLEAR_STATE: 'CLEAR_STATE',
  CLEAR_SEARCH_TERM: 'CLEAR_SEARCH_TERM',
  CLEAR_OPTION_VALUES: 'CLEAR_OPTION_VALUES'
}

const getDefaultState = () => {
  return {
    pageStates: generatePageStates(),
    selectedCategories: [],
    searchTerm: null,
    levelValue: 'ALL',
    optionValues: [
      {
        label: 'Kids in Motion',
        value: 'kids-in-motion',
        selected: false
      },
      {
        label: 'OVB Coach',
        value: 'ovb-coach',
        selected: false
      },
      {
        label: 'Primitive Reflex Library',
        value: 'primitive-reflex-library',
        selected: false
      },
      {
        label: 'We Move',
        value: 'we-move',
        selected: false
      },
      {
        label: 'Clinic Videos',
        value: 'clinic-videos',
        selected: false
      }
    ],
    lastSelection: '',
    layoutValues: [
      {
        label: 'Grid',
        value: 'GRID',
        selected: true
      }
    ]
  }
}

// initial state
const state = getDefaultState()

const targetPageState = (state, viewName) => {
  return state.pageStates.find(tgtState => tgtState.name === viewName)
}
// apply state
const applyState = (state, viewName, tgtProp, payload) => {
  const tgtState = targetPageState(state, viewName)
  tgtState[tgtProp] = payload
}

// getters
const getters = {
  pageStates: state => state.pageStates
}

// actions
const actions = {
  setLayoutValues ({ commit }, payload) {
    commit(types.SET_LAYOUT_VALUES, payload)
  },
  setCategorySelections ({ commit }, payload) {
    commit(types.SET_CATEGORY_SELECTIONS, payload)
  },
  setSearchTerm ({ commit }, payload) {
    commit(types.SET_SEARCH_TERM, payload)
  },
  setLastSelection ({ commit }, payload) {
    commit(types.SET_LAST_SELECTION, payload)
  },
  clearState ({ commit }, viewName) {
    commit(types.CLEAR_STATE, viewName)
  },
  clearOptionValues ({ commit }, viewName) {
    commit(types.CLEAR_OPTION_VALUES, viewName)
  },
  setOptionValues ({ commit }, payload) {
    commit(types.SET_OPTION_VALUES, payload)
  },
  clearSearchTerm ({ commit }, viewName) {
    commit(types.CLEAR_SEARCH_TERM, viewName)
  }
}

// mutations
const mutations = {
  [types.SET_LAYOUT_VALUES] (state, payload) {
    applyState(state, payload.viewName, 'layoutValues', payload.data)
  },
  [types.SET_OPTION_VALUES] (state, payload) {
    applyState(state, payload.viewName, 'optionValues', payload.data)
  },
  [types.SET_LEVEL_VALUE] (state, payload) {
    applyState(state, payload.viewName, 'levelValue', payload.data)
  },
  [types.SET_CATEGORY_SELECTIONS] (state, payload) {
    applyState(state, payload.viewName, 'selectedCategories', payload.data)
    // state.selectedCategories = payload
  },
  [types.SET_SEARCH_TERM] (state, payload) {
    applyState(state, payload.viewName, 'searchTerm', payload.data)
    // state.searchTerm = payload
  },
  [types.SET_LAST_SELECTION] (state, payload) {
    applyState(state, payload.viewName, 'lastSelection', payload.data)
  },
  [types.CLEAR_STATE] (state, viewName) {
    const tgtIndex = state.pageStates.findIndex(pgState => pgState.name === viewName)
    state.pageStates[tgtIndex].layoutValues = [...defaultLayoutValues]
    state.pageStates[tgtIndex].optionValues = [...defaultOptionValues]
    state.pageStates[tgtIndex].searchTerm = ''
    state.pageStates[tgtIndex].selectedCategories = []
    eventBus.$emit('CLEARED_VIDEO_BROWSER_STATE', viewName)
  },
  [types.CLEAR_OPTION_VALUES] (state, viewName) {
    const tgtIndex = state.pageStates.findIndex(pgState => pgState.name === viewName)
    state.pageStates[tgtIndex].optionValues = [...defaultOptionValues]
  },
  [types.CLEAR_SEARCH_TERM] (state, viewName) {
    const tgtIndex = state.pageStates.findIndex(pgState => pgState.name === viewName)
    state.pageStates[tgtIndex].searchTerm = ''
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
